var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#919191",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 10.833c-2.353 0-4.44.532-5.813.995a2.492 2.492 0 0 0-1.687 2.365V17.5h6.667M12.083 15h6.667v4.167h-6.667zM13.75 15v-2.5c0-.917.75-1.667 1.667-1.667.916 0 1.666.75 1.666 1.667V15M8.75 10.833c-2.3 0-4.167-2.699-4.167-5V5a4.167 4.167 0 0 1 8.333 0v.833c0 2.301-1.865 5-4.166 5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminGrey);
export default __webpack_public_path__ + "static/media/admin-grey.a9c477a92e1dbef204fe848d4fa23c44.svg";
export { ForwardRef as ReactComponent };